<div class="flex flex-col gap-2 -mt-0.5 -mx-0.5 mb-8 max-h-[500px] overflow-y-auto scrollbar-thin">
  <ws-asset-details-card
    *ngFor="let asset of assets$ | async"
    class="m-0.5"
    [asset]="asset"
    [session]="session"
    [staffView]="staffView"
    [selected]="asset.id === selected?.id"
    (clicked)="selectAsset(asset)"
    (edit)="openEditDialog($any($event))"
    (deleted)="onDeleted($any($event))"
  ></ws-asset-details-card>

  <ws-edit-asset-dialog #editAssetDialog (closed)="onEditClosed($event)"></ws-edit-asset-dialog>
</div>
